import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnBtnCard from '../atoms/columnBtnCard'
import ColumnH1 from '../atoms/columnH1'

const Wrapper = styled.article`
  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    span {
      display: none;
    }
  }
  ${BreakPoints.large} {
    margin-bottom: 10px;
  }
`

/**
 * 関連記事カードセット
 * TODO 川上申し送り事項：記事詳細下部に表示されるコンポーネントです。
 * ここでは、表示している記事に関連した他の記事3件が表示される予定です
 * @constructor
 */
const ColumnRelationCards0081 = () => (
  <Wrapper>
    <ColumnH1 label="関連コラム" />
    <section>
      <ColumnBtnCard
        href="/column/details/C0080"
        imgId="c0080.jpg"
        label="半休は有給取得義務の5日に含められる？半休の日の残業代、残業と時間休を併用する場合は？"
        date="2025.05.12"
      />
    </section>
  </Wrapper>
)

export default ColumnRelationCards0081
